import { gql } from '@/apollo';

export const UPDATE_ARCHIVE_CONDITION_MUTATION = gql(`
  mutation updateArchiveConditionMutation(
    $workflowConfigRowId: BigInt!
    $archiveCondition: JSON
  ) {
    updateWorkflowConfigByRowId(
      input: {
        rowId: $workflowConfigRowId
        patch: { archiveCondition: $archiveCondition }
      }
    ) {
      workflowConfig {
        rowId
        archiveCondition
      }
    }
  }
`);
